import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ReferralsService = {
    list: async () => axios.post(API_URL + "/referrals/list").then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getReferral/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/referrals`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/referrals/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/referrals/${id}`).then(({data}) => data).catch((err) => { throw err }),
}

export default ReferralsService;
